export default "__VITE_ASSET___WbaNJLH__"